/**
 * @generated SignedSource<<466840aa7dbc5e6b422e71b987672f0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ArchiveCompanyInput = {
  companyId: string;
};
export type useCompanyArchiveMutation$variables = {
  input: ArchiveCompanyInput;
};
export type useCompanyArchiveMutation$data = {
  readonly archiveCompany: {
    readonly company: {
      readonly id: string;
      readonly deletedAt: any | null;
      readonly organization: {
        readonly id: string;
        readonly totalCompanies: {
          readonly totalCount: number;
        };
      } | null;
    };
  } | null;
};
export type useCompanyArchiveMutation = {
  variables: useCompanyArchiveMutation$variables;
  response: useCompanyArchiveMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ArchiveCompanyPayload",
    "kind": "LinkedField",
    "name": "archiveCompany",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deletedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": "totalCompanies",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "includeDeleted",
                    "value": "NO"
                  }
                ],
                "concreteType": "CompaniesConnection",
                "kind": "LinkedField",
                "name": "companies",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  }
                ],
                "storageKey": "companies(includeDeleted:\"NO\")"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCompanyArchiveMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCompanyArchiveMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "124d8130196c06f9833e19ab312a58f2",
    "id": null,
    "metadata": {},
    "name": "useCompanyArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation useCompanyArchiveMutation(\n  $input: ArchiveCompanyInput!\n) {\n  archiveCompany(input: $input) {\n    company {\n      id\n      deletedAt\n      organization {\n        id\n        totalCompanies: companies(includeDeleted: NO) {\n          totalCount\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7bce4ff03aa931b011a234b0b474c6dc";

export default node;
